import { QueryObserverSuccessResult, useQuery } from "@tanstack/react-query";
import { apiPaths } from "@src/constants";
import { Themes } from "@src/api/v1/Themes";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { ResponseThemeResponse } from "@src/api/v1/data-contracts";

export const useThemesQuery = (sessionTypes: string[] | undefined) =>
  useQuery({
    queryKey: [apiPaths.themes, sessionTypes],
    queryFn: () =>
      new Themes(OpenUpHttpClient).getThemes({
        session_types: sessionTypes ?? [],
      }),
    suspense: false,
  }) as QueryObserverSuccessResult<ResponseThemeResponse[]>;
